import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function PlacesToVisit() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const attractions = [
    {
      id: 1,
      name: "1. Hawa Mahal (Palace of Winds)",
      overview: "Built in 1799 by Maharaja Sawai Pratap Singh, this iconic five-story pink sandstone structure features 953 small windows (jharokhas). It was designed to allow royal women to observe daily street celebrations without being seen by the public. The unique architectural design also creates a natural cooling effect (Venturi effect) throughout the interiors.",
      timings: "9:00 AM – 5:00 PM",
      distance: "Approx. 12 km from LNMIIT",
      tip: "The best photograph location is from the rooftop cafes directly across the street during sunrise or early morning hours.",
      imagePlaceholder: "Hawa Mahal"
    },
    {
      id: 2,
      name: "2. Amber Palace (Amer Fort)",
      overview: "Located on a hill in Amer, just outside Jaipur city, this UNESCO World Heritage Site is a masterpiece of Rajput architecture. Built by Raja Man Singh I, the fort complex is constructed from red sandstone and white marble. It features stunning halls like the Sheesh Mahal (Mirror Palace), Diwan-i-Aam, and beautifully manicured courtyards overlooking Maota Lake.",
      timings: "8:00 AM – 5:50 PM (Day) | 6:30 PM – 9:15 PM (Night Tourism)",
      distance: "Approx. 18 km from LNMIIT",
      tip: "Don't miss the spectacular Light and Sound Show in the evening, which narrates the rich history of the Kachwaha clan.",
      imagePlaceholder: "Amber Palace"
    },
    {
      id: 3,
      name: "3. City Palace",
      overview: "Located at the heart of the Old City, the City Palace is the historic seat of the Maharaja of Jaipur. The complex features an incredible blend of Rajasthani and Mughal architecture, encompassing vast courtyards, pavilions, museums, and the famous 'Pritam Niwas Chowk' which houses four beautifully decorated gates representing the four seasons.",
      timings: "9:30 AM – 5:00 PM (Day) | 7:00 PM – 10:00 PM (Night)",
      distance: "Approx. 13 km from LNMIIT",
      tip: "Opt for the composite ticket if you also plan to visit Jantar Mantar, located just a short walk away.",
      imagePlaceholder: "City Palace"
    },
    {
      id: 4,
      name: "4. Jantar Mantar",
      overview: "An absolute must-visit for researchers and scientists, Jantar Mantar is a UNESCO World Heritage Site featuring a collection of nineteen architectural astronomical instruments built by King Sawai Jai Singh II in 1734. It features the world's largest stone sundial (Vrihat Samrat Yantra) and remains a testament to ancient mathematical and astronomical prowess.",
      timings: "9:00 AM – 4:30 PM",
      distance: "Approx. 13 km from LNMIIT",
      tip: "Hiring an authorized, certified guide is highly recommended to fully appreciate how these instruments measure time, track stars, and predict eclipses.",
      imagePlaceholder: "Jantar Mantar"
    },
    {
      id: 5,
      name: "5. Albert Hall Museum",
      overview: "Functioning as the Central Museum of Rajasthan, the Albert Hall is the oldest museum in the state. Designed by Sir Samuel Swinton Jacob in the Indo-Saracenic architectural style, it opened as a museum in 1887. It boasts an extensive collection of artifacts, including miniature paintings, ivory, carpets, sculptures, and a famous Egyptian mummy.",
      timings: "9:00 AM – 5:00 PM (Day) | 7:00 PM – 10:00 PM (Night)",
      distance: "Approx. 14 km from LNMIIT",
      tip: "The museum looks absolutely breathtaking at night when it is completely illuminated with multi-colored lights.",
      imagePlaceholder: "Albert Hall Museum"
    },
    {
      id: 6,
      name: "6. Jal Mahal (Water Palace)",
      overview: "A mesmerizing palace appearing to float in the middle of the Man Sagar Lake. Built in the 18th century, this low-rise symmetrical structure is made of pink sandstone. Out of its five stories, four remain submerged underwater when the lake is full, leaving only the top floor visible.",
      timings: "Visible from the lakeside promenade 24/7 (Entry inside the palace is restricted)",
      distance: "Approx. 14 km from LNMIIT",
      tip: "Visit during sunset for pristine reflections over the water, followed by a casual stroll along the street food stalls on the promenade.",
      imagePlaceholder: "Jal Mahal"
    },
    {
      id: 7,
      name: "7. Nahargarh Fort",
      overview: "Perched edge-wise on the Aravalli Hills, Nahargarh Fort offers a commanding panoramic view of the entire city of Jaipur. Built in 1734 by Maharaja Sawai Jai Singh II as a strong defensive retreat, it was originally named Sudarshangarh. The fort houses 'Madhavendra Bhawan', a two-story complex featuring identical suites constructed for the king's nine queens.",
      timings: "10:00 AM – 5:30 PM",
      distance: "Approx. 25 km from LNMIIT",
      tip: "It is highly sought after around sunset. The rooftop restaurant/viewpoints offer an incredible evening look at the lit-up cityscape.",
      imagePlaceholder: "Nahargarh Fort"
    },
    {
      id: 8,
      name: "8. Jaigarh Fort",
      overview: "Situated atop the 'Cheel ka Teela' (Hill of Eagles) overlooking Amer Palace, Jaigarh Fort was designed to protect the lower palace complex. Built in 1726 by Sawai Jai Singh II, it is structurally highly rugged and features a massive artillery foundry. The fort is most famous for housing the 'Jaivana Cannon', which was the world's largest cannon on wheels at the time of its manufacturing.",
      timings: "9:00 AM – 4:30 PM",
      distance: "Approx. 20 km from LNMIIT",
      tip: "Walk up to the fort's watchtowers for sweeping views of the entire Aravalli range and the Amer fortifications.",
      imagePlaceholder: "Jaigarh Fort"
    },
    {
      id: 9,
      name: "9. Birla Mandir (Laxmi Narayan Temple)",
      overview: "A relatively modern architectural marvel, the Birla Mandir is constructed entirely out of high-grade white pristine marble. Built by the Birla Foundation in 1988, the temple is dedicated to Lord Vishnu and Goddess Lakshmi. The structure showcases intricate stone carvings representing mythological events, as well as portraits of international historical philosophers and scientists.",
      timings: "6:00 AM – 12:00 PM | 3:00 PM – 9:00 PM",
      distance: "Approx. 16 km from LNMIIT",
      tip: "Visit in the late evening when the pure white marble glows beautifully under artificial spotlights against the dark sky.",
      imagePlaceholder: "Birla Mandir"
    },
    {
      id: 10,
      name: "10. Chokhi Dhani (Ethnic Village Resort)",
      overview: "For delegates seeking a comprehensive experience of traditional Rajasthani culture, Chokhi Dhani is a widely renowned ethnic village setup. It offers live folk dance performances (Ghoomar, Kalbeliya), puppet shows, traditional arts and crafts, camel rides, and an authentic, elaborate Rajasthani dining experience served on leaf platters.",
      timings: "5:00 PM – 11:00 PM (Evening experience)",
      distance: "Approx. 28 km from LNMIIT",
      tip: "Perfect option for a post-conference evening team-dinner or excursion with delegates to experience authentic hospitality.",
      imagePlaceholder: "Chokhi Dhani"
    }
  ];

  return (
    <div className="page-container">
      <PageCarousel />
      <section className="section-padding text-dark">
        <div className="container">
          
          {/* Main Headers */}
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center mb-4">
              <span className="text-uppercase fw-bold tracking-wider" style={{ color: '#70b60a', fontSize: '14px', letterSpacing: '2px' }}>
                Exploring The Pink City
              </span>
              <h1 className="section-title mt-2 mb-3 fw-bold" style={{ fontSize: '2.5rem' }}>
                An Extended Delegate's Guide to Places to Visit in Jaipur, Rajasthan
              </h1>
              <p className="text-muted leading-relaxed mx-auto" style={{ maxWidth: '850px', fontSize: '16px' }}>
                Welcome to Jaipur, the magnificent capital of Rajasthan, globally renowned as the 'Pink City'. 
                Rich in history, architectural grandeur, and vibrant culture, Jaipur offers an unforgettable experience. 
                This expanded list has been specifically prepared for our conference delegates to help you make the most 
                of your stay during the event.
              </p>
            </div>
          </div>

          {/* Attractions Grid */}
          <div className="row justify-content-center mt-4">
            <div className="col-lg-10">
              <div className="row g-4">
                {attractions.map((place) => (
                  <div key={place.id} className="col-12">
                    <div className="card shadow-sm border-0 bg-white rounded-3 overflow-hidden">
                      <div className="row g-0">
                        {/* Left Side: Dynamic Image Area */}
                        <div className="col-md-4 position-relative bg-light d-flex align-items-center justify-content-center border-end" style={{ minHeight: '220px' }}>
                          <img 
                            src={`/assets/img/gallery/${place.imagePlaceholder.toLowerCase().replace(/ /g, '_')}.jpg`} 
                            alt={place.imagePlaceholder}
                            className="w-100 h-100 position-absolute start-0 top-0"
                            style={{ objectFit: 'cover' }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                          <div className="text-center p-3 text-secondary position-relative">
                            <i className="fa-solid fa-camera-retro fa-2x mb-2" style={{ color: '#70b60a' }}></i>
                            <div className="fw-semibold small">{place.imagePlaceholder}</div>
                          </div>
                        </div>

                        {/* Right Side: Information Data */}
                        <div className="col-md-8 p-4 d-flex flex-column justify-content-between">
                          <div>
                            <h3 className="h5 fw-bold mb-2" style={{ color: '#333' }}>{place.name}</h3>
                            <p className="text-muted small mb-3" style={{ textAlign: 'justify', lineHeight: '1.5' }}>
                              {place.overview}
                            </p>
                          </div>

                          <div className="border-top pt-3 mt-2">
                            <div className="row g-2 text-dark small">
                              <div className="col-sm-6">
                                <strong><i className="fa-regular fa-clock me-1 text-secondary"></i> Timings:</strong><br />
                                <span className="text-muted">{place.timings}</span>
                              </div>
                              <div className="col-sm-6">
                                <strong><i className="fa-solid fa-location-dot me-1 text-secondary"></i> Distance:</strong><br />
                                <span className="text-muted">{place.distance}</span>
                              </div>
                            </div>

                            {/* Delegate Tip Alert Box */}
                            <div className="mt-3 p-2 rounded small" style={{ backgroundColor: '#fdfbc8', borderLeft: '3px solid #70b60a', color: '#555' }}>
                              <strong><i className="fa-solid fa-lightbulb me-1" style={{ color: '#70b60a' }}></i> Delegate Tip:</strong> {place.tip}
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Practical Travel Recommendations Block */}
          <div className="row justify-content-center mt-5">
            <div className="col-lg-10">
              <div className="p-4 shadow-sm bg-white border border-2 rounded-3" style={{ borderColor: '#70b60a' }}>
                <h4 className="fw-bold mb-4" style={{ color: '#70b60a' }}>
                  <i className="fa-solid fa-circle-info me-2"></i>Practical Travel Recommendations for Attendees
                </h4>
                
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-start">
                    <span className="badge mt-1 me-3 p-2" style={{ backgroundColor: '#70b60a' }}><i className="fa-solid fa-car"></i></span>
                    <div>
                      <strong>Transportation:</strong> For ease of travel, delegates are advised to book pre-paid cabs via reliable smartphone applications (Ola/Uber) or utilize the Jaipur Metro lines where accessible. For local sightseeing inside the old city walls, electric rickshaws are highly convenient.
                    </div>
                  </div>

                  <div className="d-flex align-items-start">
                    <span className="badge mt-1 me-3 p-2" style={{ backgroundColor: '#70b60a' }}><i className="fa-solid fa-ticket"></i></span>
                    <div>
                      <strong>Composite Tickets:</strong> If planning to visit multiple heritage monuments like Amber Palace, Albert Hall, Nahargarh, and Jantar Mantar, purchasing a 'Composite Ticket' issued by the Department of Archaeology & Museums (Government of Rajasthan) is highly economical.
                    </div>
                  </div>

                  <div className="d-flex align-items-start">
                    <span className="badge mt-1 me-3 p-2" style={{ backgroundColor: '#70b60a' }}><i className="fa-solid fa-cloud-sun"></i></span>
                    <div>
                      <strong>Weather & Attire:</strong> Jaipur exhibits a pleasant climate during peak academic conference seasons, though evenings can get cool. Comfortable walking shoes are highly recommended for fort visits due to cobblestone paths and steep inclines.
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default PlacesToVisit;